export enum SUGGESTION_STATE {
  PENDING = 'pending',
  APPLIED = 'applied',
  DISMISSED = 'dismissed',
  STALE = 'stale',
}
export enum SUGGESTION_CATEGORY {
  SPELLING_AND_GRAMMAR = 'spellingAndGrammar',
  SOP_RECOMMENDATIONS = 'sopRecommendations',
  TRACKING_INCONSISTENCY = 'trackingInconsistency',
}
export type SuggestionDetailT = {
  id: string;
  questionnaireId: string;
  questionId: string;
  answer: string;
  suggestion: {
    positionStart: number;
    positionEnd: number;
    message: string;
    suggestion: string;
  };
  category: SUGGESTION_CATEGORY.SPELLING_AND_GRAMMAR | SUGGESTION_CATEGORY.SOP_RECOMMENDATIONS;
  automationRequestId?: string;
  state?: SUGGESTION_STATE; // adding this as optional to avoid type error when state is not provided
  suggestionIndex?: number;
  trackId?: string;
};
export type InconsistencyDetailT = {
  id: string;
  startIndex: number;
  endIndex: number;
  category: SUGGESTION_CATEGORY.TRACKING_INCONSISTENCY;
  suggestion?: string;
  state?: SUGGESTION_STATE;
  annotationId: string;
};
export type ReviewSuggestionsDetailT = SuggestionDetailT | InconsistencyDetailT;
export const SUGGESTION_ACTION = {
  ACCEPT: 'accept',
  DISMISS: 'dismiss'
};
export type SuggestionActionT = (typeof SUGGESTION_ACTION)[keyof typeof SUGGESTION_ACTION];
export type FocussedSuggestionItemOptionsT = {
  questionnaireId: string;
  trackId?: string;
  questionId?: string;
};
export type FocussedInconsistencyItemOptionsT = {
  startIndex: number;
  endIndex?: number;
};
export type FocusSuggestionOptionsT = FocussedSuggestionItemOptionsT | FocussedInconsistencyItemOptionsT;
export type FocussedSuggestionMetaT = {
  [suggestionCategory: string]: FocusSuggestionOptionsT;
};
export type FocusedSuggestionT = {
  id: string;
  category: SUGGESTION_CATEGORY;
  meta?: FocussedSuggestionMetaT;
};
export type onFocusSuggestionFunctionT = (id: string, options: FocusSuggestionOptionsT, category: SUGGESTION_CATEGORY) => void;
export type PanelStateT = {
  isLoading?: boolean;
  hasError?: boolean;
  isStale?: boolean;
};